module.exports = __webpack_public_path__ + "img/image_webinars02@2x.84168671.png";